import { unit } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled.div `
  position: sticky;
  z-index: 1;
  top: 0;
  margin-bottom: ${unit(4)};
`;
